exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#email-template-input-container[data-v-767311b3] {\n  max-width: calc(100% - 115px);\n  overflow-x: hidden;\n}\n#email-template-input[data-v-767311b3] {\n  max-width: calc(100% - 40px);\n  flex: 1;\n}\n#allTemplatesCheckbox[data-v-767311b3] {\n  width: 30px;\n  display: flex;\n  justify-content: center;\n}", ""]);

// exports
